import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI, TratamientoDeVariableBoolean } from '../../Varios';

export const function_ABM_ART_Articulos_Listar = async () => {
    const NombreFuncion = "function_ABM_ART_Articulos_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ListarReducidoParaSelectores = async () => {
    const NombreFuncion = "function_ABM_ART_Articulos_ListarReducidoParaSelectores"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ListarReducidoParaSelectores/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ListarParaGastosPV = async () => {
    const NombreFuncion = "function_ABM_ART_Articulos_ListarParaGastosPV"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ListarParaGastosPV/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_LeerPrecio = async (CodigoArticulo, CodigoPresentacion,
    CodigoTamano, CodigoUnidadMedida, IdEEX, esCompras, esVentas, CodigoListaPrecios,
    TieneEnCuentaLPdelCliente, CodigoMonedaEnviadaPorDocumento) => {
    const NombreFuncion = "function_ABM_ART_Articulos_LeerPrecio"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/LeerPrecio/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(CodigoPresentacion) + "/" +
            await TratamientoDeParametroParaURI(CodigoTamano) + "/" +
            await TratamientoDeParametroParaURI(CodigoUnidadMedida) + "/" +
            IdEEX + "/" +
            esCompras + "/" +
            esVentas + "/" +
            await TratamientoDeParametroParaURI(CodigoListaPrecios) + "/" +
            TieneEnCuentaLPdelCliente + "/" +
            await TratamientoDeParametroParaURI(CodigoMonedaEnviadaPorDocumento));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_LeerStockCompania = async (CodigoArticulo, CodigoPresentacion,
    CodigoTamano, CodigoUnidadMedida) => {
    const NombreFuncion = "function_ABM_ART_Articulos_LeerStockCompania"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/LeerStockCompania/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(CodigoPresentacion) + "/" +
            await TratamientoDeParametroParaURI(CodigoTamano) + "/" +
            await TratamientoDeParametroParaURI(CodigoUnidadMedida));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Leer = async (CodigoArticulo) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Leer"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Clonar = async (CodigoArticulo, CodigoArticuloNuevo) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Clonar"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/Clonar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(CodigoArticuloNuevo));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_LeerStock = async (CodigoArticulo, CodigoPresentacion,
    CodigoTamano, CodigoUnidadMedida, CodigoUbicacion) => {
    const NombreFuncion = "function_ABM_ART_Articulos_LeerStock"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/LeerStock/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(CodigoPresentacion) + "/" +
            await TratamientoDeParametroParaURI(CodigoTamano) + "/" +
            await TratamientoDeParametroParaURI(CodigoUnidadMedida) + "/" +
            await TratamientoDeParametroParaURI(CodigoUbicacion));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_LeerConFiltroCompraVenta = async (CodigoArticulo, ConFiltroCompraVenta, EsCompras, EsVentas) => {
    const NombreFuncion = "function_ABM_ART_Articulos_LeerConFiltroCompraVenta"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/LeerConFiltroCompraVenta/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeVariableBoolean(ConFiltroCompraVenta) + "/" +
            await TratamientoDeVariableBoolean(EsCompras) + "/" +
            await TratamientoDeVariableBoolean(EsVentas));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_LeerPrecioDesdeWeb = async (CodigoArticulo, CodigoPresentacion, CodigoTamano, CodigoUnidadMedida) => {
    const NombreFuncion = "function_ABM_ART_Articulos_LeerPrecioDesdeWeb"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/LeerPrecioDesdeWeb/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(CodigoPresentacion) + "/" +
            await TratamientoDeParametroParaURI(CodigoTamano) + "/" +
            await TratamientoDeParametroParaURI(CodigoUnidadMedida));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ListarCompleto = async (Vendible, Comprable, Fabricable, Stockeable, Servicio,
    ExcluirVendible, ExcluirComprable, ExcluirFabricable, ExcluirStockeable, ExcluirServicio) => {
    const NombreFuncion = "function_ABM_ART_Articulos_ListarCompleto"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ListarCompleto/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeVariableBoolean(Vendible) + "/" +
            await TratamientoDeVariableBoolean(Comprable) + "/" +
            await TratamientoDeVariableBoolean(Fabricable) + "/" +
            await TratamientoDeVariableBoolean(Stockeable) + "/" +
            await TratamientoDeVariableBoolean(Servicio) + "/" +
            await TratamientoDeVariableBoolean(ExcluirVendible) + "/" +
            await TratamientoDeVariableBoolean(ExcluirComprable) + "/" +
            await TratamientoDeVariableBoolean(ExcluirFabricable) + "/" +
            await TratamientoDeVariableBoolean(ExcluirStockeable) + "/" +
            await TratamientoDeVariableBoolean(ExcluirServicio));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ListarVendibleWeb = async () => {
    const NombreFuncion = "function_ABM_ART_Articulos_ListarVendibleWeb"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ListarVendibleWeb/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_VendiblesWEB = async (Fecha) => {
    const NombreFuncion = "function_ABM_ART_Articulos_VendiblesWEB"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_VendiblesWEB/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            Fecha);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_VendiblesWEBCompleto = async (Fecha) => {
    const NombreFuncion = "function_ABM_ART_Articulos_VendiblesWEBCompleto"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_VendiblesWEBCompleto/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            Fecha);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables = async (Fecha) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/Reservables/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            Fecha);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ReservablesEstablecimiento = async (Fecha) => {
    const NombreFuncion = "function_ABM_ART_Articulos_ReservablesEstablecimiento"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ReservablesEstablecimiento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            Fecha);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ReservablesDetalle = async (CodigoArticulo, CodigoListaPrecios) => {
    const NombreFuncion = "function_ABM_ART_Articulos_ReservablesDetalle"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ReservablesDetalle/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(CodigoListaPrecios));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ReservablesDetalleEstablecimiento = async (CodigoArticulo, CodigoListaPrecios) => {
    const NombreFuncion = "function_ABM_ART_Articulos_ReservablesDetalleEstablecimiento"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ReservablesDetalleEstablecimiento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(CodigoListaPrecios));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Horarios = async (CodigoArticulo, Fecha) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Horarios"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/Horarios/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            Fecha);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_HorariosTotal = async (CodigoArticulo, Fecha) => {
    const NombreFuncion = "function_ABM_ART_Articulos_HorariosTotal"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/HorariosTotal/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            Fecha);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ListarPresentacionesArticulos = async () => {
    const NombreFuncion = "function_ABM_ART_Articulos_ListarPresentacionesArticulos"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ListarPresentacionesArticulos/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            "--");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ListarTamanosArticulos = async () => {
    const NombreFuncion = "function_ABM_ART_Articulos_ListarTamanosArticulos"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ListarTamanosArticulos/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            "--");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_ListarUnidadesMedidaArticulos = async () => {
    const NombreFuncion = "function_ABM_ART_Articulos_ListarUnidadesMedidaArticulos"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos/ListarUnidadesMedidaArticulos/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            "--");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Insertar = async (Objeto) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Insertar";

    try {
        const objetoResult = await llamadaAPI_POST("ABM_ART_Articulos/InsertarCompleto", Objeto);
        return objetoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_Articulos_Modificar = async (Objeto) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Modificar";

    try {
        await llamadaAPI_PUT("ABM_ART_Articulos/ModificarCompleto", Objeto);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_Articulos_Generar_JSON = async (CodigoArticulo, CodigoBarras, CodigoAlfa1, CodigoAlfa2, CodigoAlfa3,
    CodigoNumerico1, CodigoNumerico2, CodigoNumerico3, DescripcionCorta, Descripcion, CodigoSubtipoCompras, CodigoSubtipoVentas,
    CodigoUnidadMedidaMinima, Vendible, Comprable, Fabricable, Stockeable, Servicio, SubeStockEnRecepcion, BajaStockEnRemito,
    Oferta, FechaVigenciaWebDesde, FechaVigenciaWebHasta, Link, MultiPlanta, MultiEmpresa, CodigoCuentaContableCompra,
    CodigoCuentaContableVenta, CodigoSubCCCompra, CodigoSubCCVenta, ImporteSugeridoVenta, ImporteSugeridoCompra,
    PorcentajeIVA, BajaStockDeOtroArticulo, BajaStockCodigoArticulo, CodigoBarrasInt, CodigoBarrasProveedor, Fantasma,
    CMVPorcentajePretendido, PorcentajeImpuestosInternos, PorcentajeComisionAVendedores, PorcentajeComisionAVendedores2,
    Agrupador, PorcentajeUtilidad, PorcentajeUtilidadWeb, PorcentajeUtilidadMinimoWeb, ImporteSugeridoVentaWeb,
    ImporteSugeridoVentaMinimoWeb, Reservable, ValorEnPuntos, Seriado, SeriadoObligatorio,
    ImporteSugeridoVentaEsImporteFinal, ImporteSugeridoVentaNoSeActualiza,
    ListArticulosPresentaciones, ListArticulosTamanos, ListArticulosUnidadesMedida,
    ListPlantas, ListEmpresas) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Generar_JSON";

    try {
        const listaPresentacionesConCodigo = (ListArticulosPresentaciones && ListArticulosPresentaciones.length > 0
            ? ListArticulosPresentaciones
            : [{
                ABM_ART_Presentaciones_CodigoPresentacion: "DEF",
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_ART_Articulos_CodigoArticulo: CodigoArticulo,
                Descripcion: "Default"
            }]
        ).map(presentacion => ({
            ...presentacion,
            ABM_ART_Articulos_CodigoArticulo: CodigoArticulo
        }));

        const listaTamanosConCodigo = (ListArticulosTamanos && ListArticulosTamanos.length > 0
            ? ListArticulosTamanos
            : [{
                ABM_ART_Tamanos_CodigoTamano: "DEF",
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_ART_Articulos_CodigoArticulo: CodigoArticulo,
                Descripcion: "Default"
            }]
        ).map(tamano => ({
            ...tamano,
            ABM_ART_Articulos_CodigoArticulo: CodigoArticulo
        }));

        const listaUnidadesMedidaConCodigo = (ListArticulosUnidadesMedida && ListArticulosUnidadesMedida.length > 0
            ? ListArticulosUnidadesMedida
            : [{
                ABM_ART_UnidadesMedida_CodigoUnidadMedida: "UN",
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_ART_Articulos_CodigoArticulo: CodigoArticulo,
                Descripcion: "Default",
                EsDivisible: false,
                FactorDeConversion: 1,
                EsSoloParaVentas: false,
                EsSoloParaCompras: false
            }]
        ).map(unidadMedida => ({
            ...unidadMedida,
            ABM_ART_Articulos_CodigoArticulo: CodigoArticulo
        }));

        const listaEmpresasConCodigo = (ListEmpresas && ListEmpresas.length > 0
            ? ListEmpresas
            : [{
                ABM_ZON_Empresas_CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_ART_Articulos_CodigoArticulo: CodigoArticulo,
                Descripcion: "Default"
            }]
        ).map(empresa => ({
            ...empresa,
            ABM_ART_Articulos_CodigoArticulo: CodigoArticulo
        }));

        const listaPlantasConCodigo = (ListPlantas && ListPlantas.length > 0
            ? ListPlantas
            : [{
                ABM_ZON_Plantas_CodigoPlanta: localStorage.getItem("CodigoPlanta"),
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_ART_Articulos_CodigoArticulo: CodigoArticulo,
                Descripcion: "Default"
            }]
        ).map(planta => ({
            ...planta,
            ABM_ART_Articulos_CodigoArticulo: CodigoArticulo
        }));

        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdEstado: 10,
            CodigoArticulo: CodigoArticulo,
            CodigoBarras: CodigoBarras,
            CodigoAlfa1: CodigoAlfa1,
            CodigoAlfa2: CodigoAlfa2,
            CodigoAlfa3: CodigoAlfa3,
            CodigoNumerico1: CodigoNumerico1,
            CodigoNumerico2: CodigoNumerico2,
            CodigoNumerico3: CodigoNumerico3,
            DescripcionCorta: DescripcionCorta,
            Descripcion: Descripcion,
            CodigoSubtipoCompras: CodigoSubtipoCompras,
            CodigoSubtipoVentas: CodigoSubtipoVentas,
            CodigoUnidadMedidaMinima: CodigoUnidadMedidaMinima,
            Vendible: Vendible,
            Comprable: Comprable,
            Fabricable: Fabricable,
            Stockeable: Stockeable,
            Servicio: Servicio,
            SubeStockEnRecepcion: SubeStockEnRecepcion,
            BajaStockEnRemito: BajaStockEnRemito,
            Oferta: Oferta,
            FechaVigenciaWebDesde: FechaVigenciaWebDesde,
            FechaVigenciaWebHasta: FechaVigenciaWebHasta,
            Link: Link,
            MultiPlanta: MultiPlanta,
            MultiEmpresa: MultiEmpresa,
            CodigoCuentaContableCompra: CodigoCuentaContableCompra,
            CodigoCuentaContableVenta: CodigoCuentaContableVenta,
            CodigoSubCCCompra: CodigoSubCCCompra,
            CodigoSubCCVenta: CodigoSubCCVenta,
            ImporteSugeridoVenta: ImporteSugeridoVenta,
            ImporteSugeridoCompra: ImporteSugeridoCompra,
            PorcentajeIVA: PorcentajeIVA,
            BajaStockDeOtroArticulo: BajaStockDeOtroArticulo,
            BajaStockCodigoArticulo: BajaStockCodigoArticulo,
            CodigoBarrasInt: CodigoBarrasInt,
            CodigoBarrasProveedor: CodigoBarrasProveedor,
            Fantasma: Fantasma,
            CMVPorcentajePretendido: CMVPorcentajePretendido,
            PorcentajeImpuestosInternos: PorcentajeImpuestosInternos,
            PorcentajeComisionAVendedores: PorcentajeComisionAVendedores,
            PorcentajeComisionAVendedores2: PorcentajeComisionAVendedores2,
            Agrupador: Agrupador,
            PorcentajeUtilidad: PorcentajeUtilidad,
            PorcentajeUtilidadWeb: PorcentajeUtilidadWeb,
            PorcentajeUtilidadMinimoWeb: PorcentajeUtilidadMinimoWeb,
            ImporteSugeridoVentaWeb: ImporteSugeridoVentaWeb,
            ImporteSugeridoVentaMinimoWeb: ImporteSugeridoVentaMinimoWeb,
            Reservable: Reservable,
            ValorEnPuntos: ValorEnPuntos,
            Seriado: Seriado,
            SeriadoObligatorio: SeriadoObligatorio,
            ImporteSugeridoVentaEsImporteFinal: ImporteSugeridoVentaEsImporteFinal,
            ImporteSugeridoVentaNoSeActualiza: ImporteSugeridoVentaNoSeActualiza,            
            ListArticulosPresentaciones: listaPresentacionesConCodigo,
            ListArticulosTamanos: listaTamanosConCodigo,
            ListArticulosUnidadesMedida: listaUnidadesMedidaConCodigo,
            ListPlantas: listaPlantasConCodigo,
            ListEmpresas: listaEmpresasConCodigo
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_Articulos_ImportarSugeridosCompra = async (ColumnaCodigoArticulo, ColumnaImporteNeto, Coleccion) => {
    const NombreFuncion = "function_ABM_ART_Articulos_ImportarSugeridosCompra"

    try {
        const resulData = await llamadaAPI_POST("ABM_ART_Articulos/ImportarSugeridoCompra/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(ColumnaImporteNeto),
            Coleccion);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Eliminar = async (CodigoArticulo) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Eliminar"

    try {
        const resulData = await llamadaAPI_PUT("ABM_ART_Articulos/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            TratamientoDeParametroParaURI(CodigoArticulo));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_CargarImagenVendibleWeb = async (CodigoArticulo, Imagen) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CargarImagenVendibleWeb";

    try {
        
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            CodigoArticulo: CodigoArticulo,            
            Imagen: Imagen
        };

        await llamadaAPI_PUT("ABM_ART_Articulos/CargarImagenVendibleWeb", JSON);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};